export const capitalizeString = (str: string) => {
  if (!str) return '';
  const [firstLetter, ...rest] = str.toLocaleLowerCase();
  return firstLetter.toLocaleUpperCase() + rest.join('');
};
